import { callSelectors } from '@lifesize/nucleus';
import { createSelector } from 'reselect';
import { Observer } from '@lifesize/web-clients-core';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import callActions from 'actions/InCall/InCallVideo';

const initialData = {
  hasIncomingPresentation: false,
  isPresenting: false,
  popoutPresentation: false,
  remotePresentation: null
};

const activeCallSelector = state => callSelectors.activeCallSelector(state);
const popoutPresentationSelector = state => _get(state, 'app.inCallVideo.videoLayout.popoutPresentation');
const remotePresentationSelector = state => _get(state, 'nucleus.media.remotePresentationStream');

const desktopSelector = createSelector([
  activeCallSelector,
  popoutPresentationSelector,
  remotePresentationSelector
],
(activeCall, popoutPresentation, remotePresentation) => ({
  hasIncomingPresentation: activeCall.hasIncomingPresentation,
  isPresenting: activeCall.isPresenting,
  callFullyConnected: activeCall.callFullyConnected,
  popoutPresentation,
  remotePresentation
})
);

const popoutPresentationRerenderHandler = (oldData, newData, dispatch) => {
  if (oldData.remotePresentation &&
    oldData.popoutPresentation &&
    newData.remotePresentation &&
    newData.popoutPresentation &&
    !_isEqual(oldData.remotePresentation, newData.remotePresentation)) {
    dispatch(callActions.togglePopout(false));
    dispatch(callActions.waitingToRepop(true));
  }
};

const newStateHandler = (oldData, newData, dispatch) => {
  popoutPresentationRerenderHandler(oldData, newData, dispatch);

  window.desktopApp.onStateChanged(oldData, newData);
};

export const handlerMethods = [desktopSelector, initialData, newStateHandler];
export default Observer.createObserver(...handlerMethods);
